<template>
    <div class="datatable">
        <h2>Bookmarks</h2>
        <p>({{ bookmarks.length }} bookmark{{ bookmarks.length !== 1 ? 's' : '' }})</p>

        <form class="quick-form" @submit.prevent="addBookmark">
            <input
                v-model.trim="newBookmark.title"
                type="text"
                placeholder="Title"
                required
            />
            <input
                v-model.trim="newBookmark.link"
                type="url"
                placeholder="https://example.com"
                required
            />
            <button class="green-btn" type="submit" :disabled="submitting">
                {{ submitting ? 'Adding...' : 'Add bookmark' }}
            </button>
        </form>

        <table>
            <thead>
            <tr>
                <th>Title</th>
                <th>Link</th>
                <th>Action</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="bookmark in bookmarks" :key="bookmark._id">
                <td>{{ bookmark.title }}</td>
                <td><a :href="bookmark.link" target="_blank" rel="noopener">{{ bookmark.link }}</a></td>
                <td>
                    <button class="green-btn danger" @click="confirmDelete(bookmark._id)">
                        <font-awesome-icon icon="times" />
                    </button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import Swal from "sweetalert2";

    export default {
        name: "AdminBookmarks",
        created() {
            this.getBookmarks();
        },
        data() {
            return {
                newBookmark: {
                    title: '',
                    link: ''
                },
                submitting: false
            };
        },
        computed: {
            ...mapGetters('bookmark', ['bookmarks'])
        },
        methods: {
            ...mapActions('bookmark', ['getBookmarks', 'createBookmark', 'deleteBookmark']),
            addBookmark() {
                if (!this.newBookmark.title || !this.newBookmark.link) {
                    return;
                }

                this.submitting = true;
                this.createBookmark({ ...this.newBookmark })
                    .then(() => {
                        Swal.fire('Created', 'Bookmark added.', 'success');
                        this.newBookmark.title = '';
                        this.newBookmark.link = '';
                    })
                    .catch(() => {
                        Swal.fire('Error', 'Could not create bookmark.', 'error');
                    })
                    .finally(() => {
                        this.submitting = false;
                    });
            },
            confirmDelete(id) {
                Swal.fire({
                    title: 'Delete this bookmark?',
                    text: "This action cannot be undone.",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it'
                }).then((result) => {
                    if (result.value) {
                        this.deleteBookmark(id)
                            .then(() => {
                                Swal.fire('Deleted!', 'Bookmark deleted.', 'success');
                            });
                    }
                });
            },
            formatDate(date) {
                return date ? new Date(date).toLocaleString() : '';
            }
        }
    }
</script>

<style scoped lang="scss">
    h2 {
        margin-bottom: 10px;
    }

    .quick-form {
        display: flex;
        gap: 10px;
        align-items: center;
        margin-bottom: 20px;
    }

    .quick-form input {
        flex: 1;
        padding: 8px 10px;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
    }

    .quick-form button {
        min-width: fit-content;
        padding: 5px 10px;
        border-radius: 4px;
        margin: 0;
    }

    table {
        width: 100%;
    }

    td, th {
        text-align: left;
        padding: 10px;
        word-break: break-word;
    }

    .green-btn.danger {
        background-color: var(--danger);
    }
</style>
